import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React from "react";

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    }
}));

type Props = {
    open : boolean;
    onClose : () => void;
    message : string;
    isLoading : boolean;
};

const SubmitAllTimeDialog : React.FC<Props> = ({open, onClose, message, isLoading} : Props) =>{
    const classes = useStyles();
    return <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle disableTypography>
            <Typography variant="h6">Submitting All Time</Typography>
            <IconButton className={classes.closeButton} onClick={onClose} airia-label="close">
                <CloseIcon/>
            </IconButton>
        </DialogTitle>
        <DialogContent>
            {isLoading && <CircularProgress size={25}/>}
            <Typography>{message}</Typography>
        </DialogContent>
    </Dialog>;
}

export default SubmitAllTimeDialog;